<template>
  <fragment>
    <ConfigureModalityForm
      :value="value"
      :error-messages="limitCreditModalityErrorMessage"
      :prize-rules="prizeRules"
    >
      <template v-slot:header>
        <FormSection>
          <v-row>
            <v-col cols="12" sm="5" class="pr-sm-5">
              <BaseFormSelect
                id-element="nameModality"
                :items="modalities"
                v-model="value.modalidade"
                item-text="nome"
                item-value="id"
                :return-object="true"
                placeholder="Selecionar"
                label-text="Modalidade"
                required
                :rules="[requiredInput]"
                :disabled="isEdit"
              />
            </v-col>
            <v-col cols="12" sm="7" class="mb-2" v-if="userAreaIsGarantia">
              <BaseFormAutocompleteSelectable
                v-model="value.tomador"
                id-element="companyModality"
                :items="companies"
                item-text="nome_fantasia"
                item-value="id"
                :return-object="true"
                :label-text="textMatrizFilial"
                placeholder="Razão Social / CNPJ"
                template-taker
                :disabled="isEdit"
              />
            </v-col>
            <v-col cols="12" sm="7" class="pb-5" v-if="isEdit">
              <p class="form__label mb-5 primary--text">
                Status
              </p>
              <v-switch
                v-model="value.ativo"
                class="pa-0 ma-0 justify-self-center d-inline-block base-form-switch"
                dense
                inset
                hide-details
                color="secondary"
              />
              <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
                {{ statusModality }}
              </p>
            </v-col>
          </v-row>
        </FormSection>
        <v-divider />
      </template>
    </ConfigureModalityForm>
    <v-divider />
    <ModalitySelection
      :items="value.submodalidades"
      :error-messages="submodalityErrorMessage"
      title="SUB MODALIDADES"
      v-bind="[$attrs, $props]"
      v-on="$listeners"
      type-item="submodality"
      :button-new-item="canAddSubmodality"
    />
    <BaseFooter>
      <div class="d-flex justify-end">
        <BaseButton
          class="error text-uppercase subtitle-2 font-weight-bold"
          min-width="200"
          @click="$emit('cancel')"
        >
          CANCELAR
        </BaseButton>
        <BaseButton
          @click="$emit('save-step', 'modality')"
          class="secondary text-uppercase subtitle-2 font-weight-bold ml-5"
          min-width="200"
        >
          SALVAR
        </BaseButton>
      </div>
    </BaseFooter>
  </fragment>
</template>

<script>
import { requiredInput } from "@/utils/rules.js";
import ConfigureModalityForm from "../../../components/ConfigureModalityForm.vue";
import FormSection from "@/components/FormSection.vue";
import ModalitySelection from "../../../components/form/ModalitySelection";
import _ from "lodash";
import { mapState } from "vuex";

export default {
  name: "ConfigureModality",
  components: { FormSection, ConfigureModalityForm, ModalitySelection },
  props: {
    modalityModel: Object,
    companies: Array,
    modalities: Array,
    submodalityErrorMessage: Array,
    isEdit: Boolean,
    formValid: Boolean,
    limitCredit: Number,
    limitCreditModalityErrorMessage: Array,
    prizeRules: Array
  },
  nextStep() {
    return import("./ConfigureSubModality.vue").then(c => c.default);
  },
  previousStep() {
    return import("./ConfigureModalitySection.vue").then(c => c.default);
  },
  data: () => ({
    requiredInput,
    value: null
  }),
  created() {
    this.value = this.modalityModel;
    this.value.valor_limite_credito =
      this.value.valor_limite_credito == 0
        ? _.cloneDeep(this.limitCredit)
        : this.value.valor_limite_credito;
  },
  computed: {
    ...mapState("me", ["userAreaIsGarantia"]),
    statusModality() {
      return this.value && this.value.ativo ? "Ativo" : "Inativo";
    },
    canAddSubmodality() {
      return Boolean(
        this.value.submodalidades.length == 0 && this.value.modalidade
      );
    },
    textMatrizFilial() {
      return this.userAreaIsGarantia ? "Tomador Matriz/Filial" : "Matriz/Filial";
    }
  }
};
</script>
